import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { WebApiModel } from '../../../models/web-api.model';
import { StateRxService } from '../../../services/staterx.service';

@Component({
  selector: 'hcf-popup-map',
  templateUrl: './popup-map.component.html',
  styleUrls: ['./popup-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PopupMapComponent implements OnDestroy {
  mapExpanded: boolean = false;
  showSidebar: boolean = false;
  selectedLocation: WebApiModel.Location;
  locationType: string;

  @Input() placesForMap: WebApiModel.Location[];
  @Input() latitude: number;
  @Input() longitude: number;

  private _subscriptionToggleSidebar: Subscription;

  constructor(_stateRx: StateRxService) {
    this._subscriptionToggleSidebar = _stateRx.toggleMapSidebar.rxSubscribe((location) => {
      this.toggleSidebar(location);
    });
  }

  done() {
    this.mapExpanded = false;
  }

  openPopupMap() {
    this.showSidebar = false;
    this.mapExpanded = true;
  }

  closePopupMap() {
    this.showSidebar = false;
    this.mapExpanded = false;
  }

  backTo() {
    if (this.showSidebar) {
      this.toggleSidebar(null); // will close the side bar and go back to the map
    } else {
      // Otherwise close the map
      this.closePopupMap();
    }
  }

  toggleSidebar(location: WebApiModel.Location) {
    if (location) {
      this.selectedLocation = location;
      this.showSidebar = true;
      if (location.locationDetails.findIndex((x) => x.displayName != null) >= 0) {
        this.locationType = 'Doctors';
      } else {
        this.locationType = 'Practices';
      }
    } else {
      this.showSidebar = false;
    }
  }

  ngOnDestroy() {
    this._subscriptionToggleSidebar.unsubscribe();
  }
}
